var CommonApiMethods;
(function (CommonApiMethods) {
    CommonApiMethods["GetDecisionTree"] = "getDecisionTree";
    CommonApiMethods["GetParameters"] = "getParameters";
    CommonApiMethods["GetSimpleMetricTemplates"] = "getSimpleMetricTemplates";
    CommonApiMethods["GetRelativeMetricTemplates"] = "getRelativeMetricTemplates";
    CommonApiMethods["GetLicenses"] = "getLicenses";
    CommonApiMethods["UploadActivationLicenseFile"] = "uploadActivationLicenseFile";
    CommonApiMethods["UploadDeactivationLicenseFile"] = "uploadDeactivationLicenseFile";
    CommonApiMethods["GenerateCapabilityRequestFile"] = "generateCapabilityRequestFile";
    CommonApiMethods["GenerateDeactivateCapabilityRequestFile"] = "generateDeactivateCapabilityRequestFile";
    CommonApiMethods["ActivateLicenseKey"] = "activateLicenseKey";
    CommonApiMethods["DeactivateLicenseKey"] = "deactivateLicenseKey";
    CommonApiMethods["GetVersion"] = "getVersion";
    CommonApiMethods["SetUserMetric"] = "setUserMetric";
    CommonApiMethods["GetAllUsers"] = "getAllUsers";
    CommonApiMethods["GetAllowedUsers"] = "getAllowedUsers";
    CommonApiMethods["GetNotAllowedUsers"] = "getNotAllowedUsers";
    CommonApiMethods["EditUsersAccess"] = "editUsersAccess";
    CommonApiMethods["RemoveUsersAccess"] = "removeUsersAccess";
    CommonApiMethods["UserInfo"] = "userInfo";
})(CommonApiMethods || (CommonApiMethods = {}));
var PointScalingApiMethods;
(function (PointScalingApiMethods) {
    PointScalingApiMethods["GetPsTags"] = "getPsTags";
    PointScalingApiMethods["GetPsWorkspacesList"] = "getPsWorkspacesList";
    PointScalingApiMethods["GetPsWorkspace"] = "getPsWorkspace";
    PointScalingApiMethods["ValidatePsWorkspaceForImport"] = "validatePsWorkspaceForImport";
    PointScalingApiMethods["ExportPsWorkspace"] = "exportPsWorkspace";
    PointScalingApiMethods["ImportPsWorkspace"] = "importPsWorkspace";
    PointScalingApiMethods["ExportScenario"] = "exportScenario";
    PointScalingApiMethods["UpdatePsWorkspaceName"] = "updatePsWorkspaceName";
    PointScalingApiMethods["UpdatePsWorkspaceDescription"] = "updatePsWorkspaceDescription";
    PointScalingApiMethods["SavePsWorkspace"] = "savePsWorkspace";
    PointScalingApiMethods["DuplicatePsWorkspace"] = "duplicatePsWorkspace";
    PointScalingApiMethods["GetPsWorkspaceLayout"] = "getPsWorkspaceLayout";
    PointScalingApiMethods["CreatePsTag"] = "createPsTag";
    PointScalingApiMethods["LinkPsTags"] = "linkPsTags";
    PointScalingApiMethods["UnlinkPsTag"] = "unlinkPsTag";
    PointScalingApiMethods["GetPsBioreactors"] = "getPsBioreactors";
})(PointScalingApiMethods || (PointScalingApiMethods = {}));
var RecipeScalingApiMethods;
(function (RecipeScalingApiMethods) {
    RecipeScalingApiMethods["GetRsTags"] = "getRsTags";
    RecipeScalingApiMethods["GetRsWorkspacesList"] = "getRsWorkspacesList";
    RecipeScalingApiMethods["GetCellModelsList"] = "getCellModelsList";
    RecipeScalingApiMethods["GetCellModel"] = "getCellModel";
    RecipeScalingApiMethods["ExportCellModel"] = "exportCellModel";
    RecipeScalingApiMethods["CellModelUpload"] = "cellModelUpload";
    RecipeScalingApiMethods["CellModelParseFile"] = "cellModelParseFile";
    RecipeScalingApiMethods["CellModelImportFromFileId"] = "cellModelImportFromFileId";
    RecipeScalingApiMethods["GetCellModelTemporary"] = "getCellModelTemporary";
    RecipeScalingApiMethods["GetCellModelVariables"] = "getCellModelVariables";
    RecipeScalingApiMethods["GetCellModelDynamicNames"] = "getCellModelDynamicNames";
    RecipeScalingApiMethods["GetCellModelPopulationNames"] = "getCellModelPopulationNames";
    RecipeScalingApiMethods["AddVariable"] = "addVariable";
    RecipeScalingApiMethods["DeleteVariable"] = "deleteVariable";
    RecipeScalingApiMethods["SaveCellModel"] = "saveCellModel";
    RecipeScalingApiMethods["DuplicateCellModel"] = "duplicateCellModel";
    RecipeScalingApiMethods["CancelCellModel"] = "cancelCellModel";
    RecipeScalingApiMethods["AddPopulation"] = "addPopulation";
    RecipeScalingApiMethods["EditPopulation"] = "editPopulation";
    RecipeScalingApiMethods["DeletePopulation"] = "deletePopulation";
    RecipeScalingApiMethods["AddDynamic"] = "addDynamic";
    RecipeScalingApiMethods["EditDynamic"] = "editDynamic";
    RecipeScalingApiMethods["DeleteDynamic"] = "deleteDynamic";
    RecipeScalingApiMethods["AddPopulationEffect"] = "addPopulationEffect";
    RecipeScalingApiMethods["UpdatePopulationEffect"] = "updatePopulationEffect";
    RecipeScalingApiMethods["DeletePopulationEffect"] = "deletePopulationEffect";
    RecipeScalingApiMethods["AddVariableDependency"] = "addVariableDependency";
    RecipeScalingApiMethods["UpdateVariableDependency"] = "updateVariableDependency";
    RecipeScalingApiMethods["DeleteVariableDependency"] = "deleteVariableDependency";
    RecipeScalingApiMethods["GetVariableDependencyGraphData"] = "getVariableDependencyGraphData";
    RecipeScalingApiMethods["AddEffectOnVariable"] = "addEffectOnVariable";
    RecipeScalingApiMethods["UpdateEffectOnVariable"] = "updateEffectOnVariable";
    RecipeScalingApiMethods["DeleteEffectOnVariable"] = "deleteEffectOnVariable";
    RecipeScalingApiMethods["GetRefinementParameters"] = "getRefinementParameters";
    RecipeScalingApiMethods["CreateRefinedCellModel"] = "createRefinedCellModel";
    RecipeScalingApiMethods["ChangeRefinementRunState"] = "changeRefinementRunState";
    RecipeScalingApiMethods["ValidateRefinement"] = "validateRefinement";
    RecipeScalingApiMethods["GetSimulationName"] = "getRsWorkspaceSimulationName";
    RecipeScalingApiMethods["AddSimulation"] = "rsWorkspaceAddSimulation";
    RecipeScalingApiMethods["EditSimulation"] = "rsWorkspaceEditSimulation";
    RecipeScalingApiMethods["ExportSimulation"] = "exportRsWorkspaceSimulation";
    RecipeScalingApiMethods["GetInsightName"] = "getRsWorkspaceInsightName";
    RecipeScalingApiMethods["AddInsight"] = "rsWorkspaceAddInsight";
    RecipeScalingApiMethods["EditInsight"] = "rsWorkspaceEditInsight";
    RecipeScalingApiMethods["DeleteInsight"] = "rsWorkspaceDeleteInsight";
    RecipeScalingApiMethods["GetInsightOperations"] = "getRsWorkspaceInsightOperations";
    RecipeScalingApiMethods["GetInsightOperationDescriptions"] = "getRsWorkspaceInsightOperationDescriptions";
    RecipeScalingApiMethods["GetInsightTransformations"] = "getRsWorkspaceInsightTransformations";
    RecipeScalingApiMethods["GetInsightEssentialCombinations"] = "getRsWorkspaceInsightEssentialCombinations";
    RecipeScalingApiMethods["GetOptimizationName"] = "getRsWorkspaceOptimizationName";
    RecipeScalingApiMethods["AddOptimization"] = "rsWorkspaceAddOptimization";
    RecipeScalingApiMethods["EditOptimization"] = "rsWorkspaceEditOptimization";
    RecipeScalingApiMethods["RsWorkspaceDeleteOptimization"] = "rsWorkspaceDeleteOptimization";
    RecipeScalingApiMethods["GetRecipeList"] = "getRecipeList";
    RecipeScalingApiMethods["GetRecipe"] = "getRecipe";
    RecipeScalingApiMethods["ExportRecipe"] = "exportRecipe";
    RecipeScalingApiMethods["ParseRecipe"] = "parseRecipe";
    RecipeScalingApiMethods["ImportRecipe"] = "importRecipe";
    RecipeScalingApiMethods["GetRecipeTemporary"] = "getRecipeTemporary";
    RecipeScalingApiMethods["SaveRecipe"] = "saveRecipe";
    RecipeScalingApiMethods["DuplicateRecipe"] = "duplicateRecipe";
    RecipeScalingApiMethods["CancelRecipe"] = "cancelRecipe";
    RecipeScalingApiMethods["GetRecipeStepsList"] = "getRecipeStepsList";
    RecipeScalingApiMethods["AddRecipeStep"] = "addRecipeStep";
    RecipeScalingApiMethods["AddWrapRecipeStep"] = "addWrapRecipeStep";
    RecipeScalingApiMethods["MoveRecipeSteps"] = "moveRecipeSteps";
    RecipeScalingApiMethods["AddRecipeStepToConcurrent"] = "addRecipeStepToConcurrent";
    RecipeScalingApiMethods["ConcurrentStepAddFlow"] = "concurrentStepAddFlow";
    RecipeScalingApiMethods["ConcurrentStepDeleteFlow"] = "concurrentStepDeleteFlow";
    RecipeScalingApiMethods["ConcurrentStepMoveFlow"] = "concurrentStepMoveFlow";
    RecipeScalingApiMethods["ConcurrentStepSetFlowMustComplete"] = "concurrentStepSetFlowMustComplete";
    RecipeScalingApiMethods["AddRecipeStepToConditional"] = "addRecipeStepToConditional";
    RecipeScalingApiMethods["AddRecipeStepToLoop"] = "addRecipeStepToLoop";
    RecipeScalingApiMethods["AddRecipeStepToAlternative"] = "addRecipeStepToAlternative";
    RecipeScalingApiMethods["ConditionalStepAddFlow"] = "conditionalStepAddFlow";
    RecipeScalingApiMethods["ConditionalStepDeleteFlow"] = "conditionalStepDeleteFlow";
    RecipeScalingApiMethods["ConditionalStepMoveFlow"] = "conditionalStepMoveFlow";
    RecipeScalingApiMethods["ConditionalStepUpdateFlow"] = "conditionalStepUpdateFlow";
    RecipeScalingApiMethods["LoopStepUpdateCondition"] = "loopStepUpdateCondition";
    RecipeScalingApiMethods["AlternativeStepAddEmptyFlow"] = "alternativeStepAddEmptyFlow";
    RecipeScalingApiMethods["AlternativeStepDuplicateFlow"] = "alternativeStepDuplicateFlow";
    RecipeScalingApiMethods["AlternativeStepDeleteFlow"] = "alternativeStepDeleteFlow";
    RecipeScalingApiMethods["AlternativeStepChangeDefaultFlow"] = "alternativeStepChangeDefaultFlow";
    RecipeScalingApiMethods["UpdateAlternativeStep"] = "updateAlternativeStep";
    RecipeScalingApiMethods["RemoveAlternativeStep"] = "removeAlternativeStep";
    RecipeScalingApiMethods["UpdateRecipeStep"] = "updateRecipeStep";
    RecipeScalingApiMethods["RemoveRecipeSteps"] = "removeRecipeSteps";
    RecipeScalingApiMethods["GetRecipeCustomVariableTransformations"] = "getRecipeCustomVariableTransformations";
    RecipeScalingApiMethods["GetRecipeCustomVariableDefaultName"] = "getRecipeCustomVariableDefaultName";
    RecipeScalingApiMethods["GetRecipeCustomVariableFormulaStatus"] = "getRecipeCustomVariableFormulaStatus";
    RecipeScalingApiMethods["AddRecipeCustomVariable"] = "addRecipeCustomVariable";
    RecipeScalingApiMethods["UpdateRecipeCustomVariable"] = "updateRecipeCustomVariable";
    RecipeScalingApiMethods["DeleteRecipeCustomVariable"] = "deleteRecipeCustomVariable";
    RecipeScalingApiMethods["GetRecipeAlternativeStepNames"] = "getRecipeAlternativeStepNames";
    RecipeScalingApiMethods["GetRecipeGasNames"] = "getRecipeGasNames";
    RecipeScalingApiMethods["GetRecipeLiquidNames"] = "getRecipeLiquidNames";
    RecipeScalingApiMethods["GetRecipeParameterNames"] = "getRecipeParameterNames";
    RecipeScalingApiMethods["AddRecipeGas"] = "addRecipeGas";
    RecipeScalingApiMethods["UpdateRecipeGas"] = "updateRecipeGas";
    RecipeScalingApiMethods["DeleteRecipeGas"] = "deleteRecipeGas";
    RecipeScalingApiMethods["AddRecipeLiquid"] = "addRecipeLiquid";
    RecipeScalingApiMethods["UpdateRecipeLiquid"] = "updateRecipeLiquid";
    RecipeScalingApiMethods["DeleteRecipeLiquid"] = "deleteRecipeLiquid";
    RecipeScalingApiMethods["AddRecipeParameter"] = "addRecipeParameter";
    RecipeScalingApiMethods["UpdateRecipeParameter"] = "updateRecipeParameter";
    RecipeScalingApiMethods["DeleteRecipeParameter"] = "deleteRecipeParameter";
    RecipeScalingApiMethods["GetRsWorkspace"] = "getRsWorkspace";
    RecipeScalingApiMethods["GetRsWorkspaceTemporary"] = "getRsWorkspaceTemporary";
    RecipeScalingApiMethods["SaveRsWorkspace"] = "saveRsWorkspace";
    RecipeScalingApiMethods["CancelRsWorkspace"] = "cancelRsWorkspace";
    RecipeScalingApiMethods["ExportRsWorkspace"] = "exportRsWorkspace";
    RecipeScalingApiMethods["RsWorkspaceUpload"] = "rsWorkspaceUpload";
    RecipeScalingApiMethods["RsWorkspaceParseFile"] = "rsWorkspaceParseFile";
    RecipeScalingApiMethods["RsWorkspaceImportFromFileId"] = "rsWorkspaceImportFromFileId";
    RecipeScalingApiMethods["RsWorkspaceAddCellModel"] = "rsWorkspaceAddCellModel";
    RecipeScalingApiMethods["RsWorkspaceAddRecipe"] = "rsWorkspaceAddRecipe";
    RecipeScalingApiMethods["RsWorkspaceAddProcessData"] = "rsWorkspaceAddProcessData";
    RecipeScalingApiMethods["RsWorkspaceDeleteCellModel"] = "rsWorkspaceDeleteCellModel";
    RecipeScalingApiMethods["RsWorkspaceDeleteRecipe"] = "rsWorkspaceDeleteRecipe";
    RecipeScalingApiMethods["RsWorkspaceDeleteSimulation"] = "rsWorkspaceDeleteSimulation";
    RecipeScalingApiMethods["RsWorkspaceDeleteProcessData"] = "rsWorkspaceDeleteProcessData";
    RecipeScalingApiMethods["CreateRsTag"] = "createRsTag";
    RecipeScalingApiMethods["LinkRsTags"] = "linkRsTags";
    RecipeScalingApiMethods["UnlinkRsTags"] = "unlinkRsTags";
    RecipeScalingApiMethods["CreateWorkspace"] = "createRsWorkspace";
    RecipeScalingApiMethods["DuplicateWorkspace"] = "duplicateRsWorkspace";
    RecipeScalingApiMethods["CreateCellModel"] = "createCellModel";
    RecipeScalingApiMethods["CreateRecipe"] = "createRecipe";
    RecipeScalingApiMethods["UpdateRsWorkspace"] = "updateRsWorkspace";
    RecipeScalingApiMethods["UpdateCellModel"] = "updateCellModel";
    RecipeScalingApiMethods["UpdateRecipe"] = "updateRecipe";
    RecipeScalingApiMethods["GetRestrictions"] = "getRestrictions";
    RecipeScalingApiMethods["CreateResultSet"] = "createResultSet";
    RecipeScalingApiMethods["MoveResultSet"] = "moveResultSet";
    RecipeScalingApiMethods["UpdateResultSet"] = "updateResultSet";
    RecipeScalingApiMethods["DeleteResultSet"] = "deleteResultSet";
    RecipeScalingApiMethods["CreateTableElement"] = "createTableElement";
    RecipeScalingApiMethods["UpdateTableElement"] = "updateTableElement";
    RecipeScalingApiMethods["UpdateTableElementView"] = "updateTableElementView";
    RecipeScalingApiMethods["CreateRecipeFromTableRow"] = "createRecipeFromTableRow";
    RecipeScalingApiMethods["CreateCellModelFromTableRow"] = "createCellModelFromTableRow";
    RecipeScalingApiMethods["CreateVariantFromTableRow"] = "createVariantFromTableRow";
    RecipeScalingApiMethods["CreateRecipeFromProcessDataViewerSource"] = "createRecipeFromProcessDataViewerSource";
    RecipeScalingApiMethods["CreateCellModelFromProcessDataViewerSource"] = "createCellModelFromProcessDataViewerSource";
    RecipeScalingApiMethods["CreateVariantFromProcessDataViewerSource"] = "createVariantFromProcessDataViewerSource";
    RecipeScalingApiMethods["CreateRecipeFromSpaceViewerSource"] = "createRecipeFromSpaceViewerSource";
    RecipeScalingApiMethods["CreateCellModelFromSpaceViewerSource"] = "createCellModelFromSpaceViewerSource";
    RecipeScalingApiMethods["CreateVariantFromSpaceViewerSource"] = "createVariantFromSpaceViewerSource";
    RecipeScalingApiMethods["CreateRecipeFromLineGraphSource"] = "createRecipeFromLineGraphSource";
    RecipeScalingApiMethods["CreateCellModelFromLineGraphSource"] = "createCellModelFromLineGraphSource";
    RecipeScalingApiMethods["CreateVariantFromLineGraphSource"] = "createVariantFromLineGraphSource";
    RecipeScalingApiMethods["UpdateResultSetElement"] = "updateResultSetElement";
    RecipeScalingApiMethods["DeleteResultSetElement"] = "deleteResultSetElement";
    RecipeScalingApiMethods["DuplicateResultSetElement"] = "duplicateResultSetElement";
    RecipeScalingApiMethods["DuplicateResultSet"] = "duplicateResultSet";
    RecipeScalingApiMethods["OrderResultSetElements"] = "orderResultSetElements";
    RecipeScalingApiMethods["GetRecipeParameterTypes"] = "getRecipeParameterTypes";
    RecipeScalingApiMethods["GetBioreactorParameters"] = "getBioreactorParameters";
    RecipeScalingApiMethods["CreateProcessDataViewerElement"] = "createProcessDataViewerElement";
    RecipeScalingApiMethods["UpdateProcessDataViewerElement"] = "updateProcessDataViewerElement";
    RecipeScalingApiMethods["CreateLineGraphElement"] = "createLineGraphElement";
    RecipeScalingApiMethods["UpdateLineGraphElement"] = "updateLineGraphElement";
    RecipeScalingApiMethods["CreateSpaceViewerElement"] = "createSpaceViewerElement";
    RecipeScalingApiMethods["UpdateSpaceViewerElement"] = "updateSpaceViewerElement";
    RecipeScalingApiMethods["SetSpaceviewerAxis"] = "setSpaceviewerAxis";
    RecipeScalingApiMethods["SetSpaceviewerSourceView"] = "setSpaceviewerSourceView";
    RecipeScalingApiMethods["SetSpaceviewerConfidence"] = "setSpaceviewerConfidence";
    RecipeScalingApiMethods["SetProcessDataViewerSourceParams"] = "setProcessDataViewerSourceParams";
    RecipeScalingApiMethods["SetLineGraphSourceParams"] = "setLineGraphSourceParams";
    RecipeScalingApiMethods["SetSpaceviewerDensity"] = "setSpaceviewerDensity";
    RecipeScalingApiMethods["CalculateTableResult"] = "calculateTableResult";
    RecipeScalingApiMethods["CalculateSpaceViewerResult"] = "calculateSpaceViewerResult";
    RecipeScalingApiMethods["GetSimulationResult"] = "getSimulationResult";
    RecipeScalingApiMethods["GetSpaceviewerResult"] = "getSpaceviewerResult";
    RecipeScalingApiMethods["GetProcessDataViewerResult"] = "getProcessDataViewerResult";
    RecipeScalingApiMethods["GetLineGraphResult"] = "getLineGraphResult";
    RecipeScalingApiMethods["GetProcessVariables"] = "getProcessVariables";
    RecipeScalingApiMethods["GetCellModelDependentWorkspaces"] = "getCellModelDependentWorkspaces";
    RecipeScalingApiMethods["UpdateCellModelDependentWorkspaces"] = "updateCellModelDependentWorkspaces";
    RecipeScalingApiMethods["GetRecipeDependentWorkspaces"] = "getRecipeDependentWorkspaces";
    RecipeScalingApiMethods["UpdateRecipeDependentWorkspaces"] = "updateRecipeDependentWorkspaces";
    RecipeScalingApiMethods["EditCalculationQueue"] = "editCalculationQueue";
    RecipeScalingApiMethods["EditCalculationQueueRow"] = "editCalculationQueueRow";
    RecipeScalingApiMethods["DeleteCalculationQueueRow"] = "deleteCalculationQueueRow";
    RecipeScalingApiMethods["EditCalculationRowsUncertainty"] = "editCalculationRowsUncertainty";
    RecipeScalingApiMethods["EditCalculationRowsVariability"] = "editCalculationRowsVariability";
    RecipeScalingApiMethods["EditCalculationRowsSteps"] = "editCalculationRowsSteps";
    RecipeScalingApiMethods["DeleteCalculationQueueElement"] = "deleteCalculationQueueElement";
    RecipeScalingApiMethods["MoveCalculationQueueElement"] = "moveCalculationQueueElement";
    RecipeScalingApiMethods["MoveCalculationQueueElementRow"] = "moveCalculationQueueElementRow";
    RecipeScalingApiMethods["StartCalculation"] = "startCalculation";
    RecipeScalingApiMethods["CancelCalculation"] = "cancelCalculation";
    RecipeScalingApiMethods["PauseCalculation"] = "pauseCalculation";
    RecipeScalingApiMethods["GetCalculationStatus"] = "getCalculationStatus";
    RecipeScalingApiMethods["GetCalculationPredictions"] = "getCalculationPredictions";
    RecipeScalingApiMethods["GetProcessDataList"] = "getProcessDataList";
    RecipeScalingApiMethods["CreateProcessDataSession"] = "createProcessDataSession";
    RecipeScalingApiMethods["RemoveProcessDataSession"] = "removeProcessDataSession";
    RecipeScalingApiMethods["UploadTimeSeries"] = "uploadTimeSeries";
    RecipeScalingApiMethods["UploadMetadata"] = "uploadMetadata";
    RecipeScalingApiMethods["DeleteTimeSeriesFile"] = "deleteTimeSeriesFile";
    RecipeScalingApiMethods["DeleteMetadataFile"] = "deleteMetadataFile";
    RecipeScalingApiMethods["CreateProcessDataFromBatch"] = "createProcessDataFromBatch";
    RecipeScalingApiMethods["UpdateProcessData"] = "updateProcessData";
    RecipeScalingApiMethods["GetProcessDataDependentWorkspaces"] = "getProcessDataDependentWorkspaces";
    RecipeScalingApiMethods["DuplicateProcessData"] = "duplicateProcessData";
    RecipeScalingApiMethods["ShareCellModelOwnership"] = "shareCellModelOwnership";
    RecipeScalingApiMethods["RevokeCellModelOwnership"] = "revokeCellModelOwnership";
    RecipeScalingApiMethods["ShareRecipeOwnership"] = "shareRecipeOwnership";
    RecipeScalingApiMethods["RevokeRecipeOwnership"] = "revokeRecipeOwnership";
    RecipeScalingApiMethods["ShareProcessDataOwnership"] = "shareProcessDataOwnership";
    RecipeScalingApiMethods["RevokeProcessDataOwnership"] = "revokeProcessDataOwnership";
    RecipeScalingApiMethods["ShareWorkspaceOwnership"] = "shareWorkspaceOwnership";
    RecipeScalingApiMethods["RevokeWorkspaceOwnership"] = "revokeWorkspaceOwnership";
    RecipeScalingApiMethods["UpdatePlotSourceConfigs"] = "updatePlotSourceConfigs";
    RecipeScalingApiMethods["GetRsBioreactors"] = "getRsBioreactors";
})(RecipeScalingApiMethods || (RecipeScalingApiMethods = {}));
export { CommonApiMethods, PointScalingApiMethods, RecipeScalingApiMethods };
